import React from "react";
import { Spinner } from "react-bootstrap";

function Loader() {
  return (
    <div className="global-loader">
      <Spinner
        animation="border"
        variant="success"
        className="loader-spinner"
      />
      <p className="mt-2">Loading...</p>
    </div>
  );
}

export default Loader;
